module.exports = "/_next/static/images/blogers-f6092556cb8a877853de69ccd64657ac.svg";